import { useAuth } from '../contexts/AuthContext';
import { DISPLAY_SCALE_MIN, DISPLAY_SCALE_MAX, setDisplayScale, useDisplayScale } from '../lib/useDisplayScale';

export default function DisplayScaleControl() {
  const { user } = useAuth();
  const scale = useDisplayScale(user?.fontScale ?? 1);
  // Embedded CUI documents already receive the outer window's scale.
  if (window.self !== window.top) return null;
  return <div data-ai-id="cui-display-scale" style={{ display: 'flex', flexDirection: 'column', alignItems: 'stretch', gap: 8, minWidth: 0 }}>
    <label>Gesamte Oberfläche
      <select aria-label="Größe der gesamten Oberfläche" value={String(Math.round(scale * 100))}
        onChange={e => setDisplayScale(Number(e.target.value) / 100)}>
        {[75, 85, 100, 115, 125, 150, 175].includes(Math.round(scale * 100)) ? null :
          <option value={Math.round(scale * 100)}>{Math.round(scale * 100)} % · Individuell</option>}
        <option value="75">75 % · Sehr klein</option>
        <option value="85">85 % · Klein — mehr Platz</option>
        <option value="100">100 % · Normal</option>
        <option value="115">115 % · Größer</option>
        <option value="125">125 % · Groß</option>
        <option value="150">150 % · Sehr groß</option>
        <option value="175">175 % · Extra groß</option>
      </select>
    </label>
    <label title="Gesamte Oberfläche einschließlich Navigation, Guide, Chats und Fenstern" style={{ display: 'flex', alignItems: 'center', gap: 5, fontSize: 12 }}>
      <span aria-hidden="true">Aa</span>
      <input aria-label="Oberfläche stufenlos skalieren" type="range" min={DISPLAY_SCALE_MIN * 100} max={DISPLAY_SCALE_MAX * 100} step={5}
        value={Math.round(scale * 100)} onChange={e => setDisplayScale(Number(e.target.value) / 100)}
        style={{ width: 82, cursor: 'pointer', accentColor: 'var(--tn-blue)' }} />
    </label>
    <button title="Auf 100 % zurücksetzen" aria-label="Oberfläche auf 100 Prozent zurücksetzen" onClick={() => setDisplayScale(1)}
      style={{ border: '1px solid var(--tn-border)', borderRadius: 4, padding: '2px 4px', background: 'transparent', color: 'var(--tn-text)', fontSize: 11, cursor: 'pointer', minWidth: 40 }}>
      {Math.round(scale * 100)}%
    </button>
  </div>;
}
